import styled from "@emotion/styled"
import qs from "qs"
import { memo, useContext } from "react"
import colors from "theme/colors"
import { ServiceCentersContext } from "./ServiceCentersContext"

const MAPS_API_KEY = "AIzaSyCjRaw8uPJc3iMAPJ4pTS82DxA6ZkiUJos"

const apiUrl = "https://maps.googleapis.com/maps/api/staticmap"

const sharedParams = {
  language: "iw",
  size: "640x640",
  maptype: "roadmap",
  key: MAPS_API_KEY,
}

const Styled = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
  `,
  MapImg: styled.img`
    width: 100%;
    object-fit: contain;

    /* align-self: flex-start; */
  `,
  Empty: styled.div`
    flex-grow: 1;
    flex-shrink: 1;
  `,
}

const StaticMap = () => {
  const { selectedCenter, centers, city, inHesder } = useContext(
    ServiceCentersContext,
  )
  const activeCenters = centers.filter(
    (item) =>
      (!city || item.city === city) &&
      (!inHesder || item.isInHesder === inHesder),
  )

  if (!selectedCenter && !activeCenters.length) {
    return null
  }

  const getStaticMapUrl = () => {
    let params

    if (selectedCenter) {
      const { longitude, latitude } = selectedCenter.location
      params = {
        zoom: "15",
        center: `${latitude},${longitude}`,
        markers: `color:0x${colors.oceanBlueTwo.replace(
          "#",
          "",
        )}|label:F|${latitude},${longitude}`,
      }
    } else {
      params = {
        markers: `color:0x${colors.oceanBlueTwo.replace(
          "#",
          "",
        )}|label:F|${activeCenters
          .map(
            (item) => `${item.location?.latitude},${item.location?.longitude}`,
          )
          .join("|")}`,
      }
    }
    const urlParams = qs.stringify(
      { ...sharedParams, ...params },
      { arrayFormat: "repeat" },
    )
    return `${apiUrl}?${urlParams}`
  }

  return (
    <Styled.Wrapper>
      <Styled.MapImg src={getStaticMapUrl()} />
      <Styled.Empty />
    </Styled.Wrapper>
  )
}

export default memo(StaticMap)
